type JobPhotoFlowInput = {
    isMobile: boolean;
    aiImageEvaluationEnabled: boolean;
    aiImageEvaluationAllowDesktop?: boolean;
    aiImageEvaluationAllowGallery?: boolean;
};

export type JobPhotoFlowEntryMode = 'AI_CAMERA' | 'AI_DESKTOP' | 'STANDARD';

export type JobPhotoFlowResult = {
    entryMode: JobPhotoFlowEntryMode;
    useAi: boolean;
    allowDesktop: boolean;
    allowGallery: boolean;
};

type ReadingImagePrimaryInput = {
    useAi: boolean;
    hasReadingValue: boolean;
    hasImages: boolean;
    imageRequired: boolean;
};

/**
 * Decides whether the reading image button is the primary action. Only one button in the reading form may be primary,
 * so the image button stays secondary as soon as the reading itself is the next expected step.
 */
export const resolveReadingImagePrimary = ({ useAi, hasReadingValue, hasImages, imageRequired }: ReadingImagePrimaryInput): boolean => {
    if (hasImages) {
        return false;
    }

    if (!hasReadingValue) {
        // in the AI flows the image is the entry point for the reading itself
        return useAi;
    }

    return imageRequired;
};

export const resolveJobPhotoFlow = ({
    isMobile,
    aiImageEvaluationEnabled,
    aiImageEvaluationAllowDesktop = false,
    aiImageEvaluationAllowGallery = false,
}: JobPhotoFlowInput): JobPhotoFlowResult => {
    if (isMobile) {
        return {
            entryMode: 'AI_CAMERA',
            useAi: aiImageEvaluationEnabled,
            allowDesktop: false,
            allowGallery: aiImageEvaluationAllowGallery,
        };
    }

    if (aiImageEvaluationEnabled && aiImageEvaluationAllowDesktop) {
        return {
            entryMode: 'AI_DESKTOP',
            useAi: true,
            allowDesktop: true,
            allowGallery: false,
        };
    }

    return {
        entryMode: 'STANDARD',
        useAi: false,
        allowDesktop: false,
        allowGallery: false,
    };
};
